import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Button from "../Button";
import Input from "./Input";

import { MdOutlineCancel } from "react-icons/md";

import ButtonToAdd from "../ButtonToAdd";
import Logo from "../Logo/Logo";
function AdjustForm(props) {
  const [extraField, setExtraField] = useState(1);
  const [showOtherForm, setShowOtherForm] = useState(false); //for only adjust

  useEffect(() => {
    setExtraField(props.generalDuplicateFormData?.arrayLength);
  }, [props.generalDuplicateFormData]);

  const onCrossHandler = () => {
    props.onChangeDropShadowHandler();
  };
  const showOtherFormToggle = (e) => {
    e.preventDefault();
    setShowOtherForm((prevState) => !prevState);
  };
  const onAddExtraField = (e) => {
    e.preventDefault();

    setExtraField((prevState) => prevState + 1);
  };

  const repeatedItemList = () => {
    let listItem = [];
    let list = "";
    for (let i = 1; i <= extraField; i++) {
      list = (
        <div
          key={i}
          className={`${
            extraField >= 2 && "border-b-[1px]"
          } border-bgwhitegrey pb-2 mb-3`}
        >
          {props.NewFormOptions.length > 0 &&
            props.NewFormOptions.map((item) => {
              return (
                <Input
                  key={item.labelName}
                  valueLabel={item.valueLabel}
                  onInputChangeHandler={props.onDuplicateInputChangeHandler}
                  type={item.type}
                  Name={item.labelName}
                  value={props.generalDuplicateFormData[item.valueLabel][i - 1]}
                  index={i - 1}
                  placeholder={item.placeholder}
                  isRequired={item.isRequired}
                  options={item.options ? item.options : ""}
                  CustomInputStyle={item.CustomInputStyle}
                  errorMsg={props.ErrorData[item.valueLabel]}
                />
              );
            })}
        </div>
      );
      listItem.push(list);
    }
    return listItem;
  };

  const form = (
    <div
      className={`py-4 md:py-4 rounded-lg   ${
        props.FormStyle ? `${props.FormStyle}` : "shadow-overlayshadow"
      } px-4 bg-bgwhite md:w-[40%] fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-30  `}
    >
      {props.CreateName !== "Login" && (
        <div
          onClick={onCrossHandler}
          className="absolute top-[3%] right-[5%] text-2xl cursor-pointer text-btnbgcolor"
        >
          <MdOutlineCancel />
        </div>
      )}

      {props.isLogo && <Logo />}

      <div className="mb-6">
        <h1 className="text-btnbgcolor mb-1 text-sm md:text-lg font-semibold text-center">
          {props.CreateName.toUpperCase()}
        </h1>
        <p className="mb-3 text-xs lg:text-lg text-center">
          Enter your credentials to {props.CreateName.toLowerCase()}
        </p>
      </div>
      <form
      //  onSubmit={props.onSubmitAdjustData}
      >
        {props.adjustedFormStock.map((item) => {
          return (
            <Input
              key={item.labelName}
              valueLabel={item.valueLabel}
              onInputChangeHandler={props.inputAdjustHandler}
              type={item.type}
              Name={item.labelName}
              value={props.InitialAdjustData[item.valueLabel]}
              placeholder={item.placeholder}
              isRequired={item.isRequired}
              options={item.options ? item.options : ""}
              CustomInputStyle={item.CustomInputStyle}
              errorMsg={props.ErrorData[item.valueLabel]}
            />
          );
        })}

        {(props.generalDuplicateFormData?.cartoon_type?.length ||
          props.generalDuplicateFormData?.plastic_type?.length) > 0 && (
          <button
            className="bg-btnbgcolor text-bgwhite text-xs md:text-base py-2 px-8 rounded hover:scale-95 active:scale-100  delay-100"
            onClick={showOtherFormToggle}
          >
            {showOtherForm ? "Hide" : "Show"}
          </button>
        )}

        {showOtherForm && (
          <>
            {props.FormOptions.map((item) => {
              if (item.inAdjust) {
                return null;
              } else {
                if (
                  item.repeatType !== true &&
                  (props.OptionNameList === "Cartoon Stock" ||
                    props.OptionNameList === "Leaf Stock")
                ) {
                  return (
                    <Input
                      key={item.labelName}
                      valueLabel={item.valueLabel}
                      onInputChangeHandler={props.onInputChangeHandler}
                      type={item.type}
                      Name={item.labelName}
                      value={props.inputFormData[item.valueLabel]}
                      placeholder={item.placeholder}
                      isRequired={item.isRequired}
                      options={item.options ? item.options : ""}
                      CustomInputStyle={item.CustomInputStyle}
                      errorMsg={props.ErrorData[item.valueLabel]}
                    />
                  );
                } else {
                  return null;
                }
              }
            })}
            {props.NewFormOptions?.length > 0 && repeatedItemList()}

            {/* seprate button to add another module */}
            {/* {props.extraAddBtn && (
              <div className="inline-block">
                <ButtonToAdd
                  text={props.extraButtonText}
                  onClick={onAddExtraField}
                />
              </div>
            )} */}
          </>
        )}

        <div
          className={`flex justify-between mt-4 ${
            (props.OptionNameList === "Product" ||
              props.OptionNameList === "Cartoon Stock" ||
              props.OptionNameList === "Leaf Stock") &&
            "w-[90%]"
          }`}
        >
          {!props.isNotCancelBtn && (
            <Button
              onClickHandler={() => window.location.reload()}
              btnStyle="bg-bgwhite border-[1px] border-btnbgcolorlight mr-2 "
              btnName="Cancel"
            />
          )}
          <Button
            type="submit"
            btnStyle={`bg-btnbgcolor text-bgwhite ${
              props.isNotCancelBtn ? "w-full" : ""
            }`}
            btnName={props.createOrUpdate}
          />
        </div>
      </form>
    </div>
  );
  return ReactDOM.createPortal(form, document.querySelector("#over-lay"));
}

export default AdjustForm;
